module.exports = __webpack_public_path__ + "static/media/star.8ce59643.png";